import React, { useState, MouseEvent } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Typography, TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store';
import { setUserProfileName } from '../../store/user-preferences-v2/actions';
import ErrorMessage from './components/error-message';
import useStyles from './styles';

const maxCharError = 'Max character limit is 50.';
const requiredFieldError = 'A display name is required.';
const helperTextProperties = { error: true };

const Preview = () => {
  const dispatch = useDispatch();
  const appState = useSelector(
    (state: AppState) => state.userPreference.customUserPreferences.displayName,
  );
  const [userDisplayName, setUserDisplayName] = useState<string>(appState || 'Jane Doe');
  const [editing, toggleEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [anchorElement, setAnchorElement] = useState(null);
  const popoverOpen = Boolean(anchorElement);
  const maxCharLimit = 50;
  const hasValidName = userDisplayName.length !== 0 && userDisplayName.length <= maxCharLimit;
  const classes = useStyles();

  const handlePopoverOpen = (event: any) => {
    setAnchorElement(event.currentTarget);
  };

  const handleSave = () => {
    toggleEditing(!editing);
    dispatch(setUserProfileName(userDisplayName));
  };

  const attemptSave = (event: MouseEvent<{}>) => {
    if (hasValidName) {
      handleSave();
    } else if (userDisplayName.length > maxCharLimit) {
      handlePopoverOpen(event);
      setErrorMessage(maxCharError);
    } else {
      handlePopoverOpen(event);
      setErrorMessage(requiredFieldError);
    }
  };

  const handleCancel = () => {
    toggleEditing(!editing);
    setUserDisplayName(appState || 'Jane Doe');
  };

  return (
    <div id="preview" className={classes.previewBlock}>
      <AccountCircleIcon className={classes.defaultProfile} />
      <div className={classes.profileDetails}>
        <div className={classes.contactInformation}>
          {!editing ? (
            <>
              <Typography className={classes.profileText && classes.displayName}>
                {appState}
                <IconButton onClick={() => toggleEditing(!editing)} aria-label="edit" size="large">
                  <EditIcon />
                </IconButton>
              </Typography>
            </>
          ) : (
            <>
              <TextField
                variant="standard"
                label={hasValidName ? 'Display Name' : 'Required'}
                defaultValue={appState}
                onChange={(event) => setUserDisplayName(event.target.value)}
                required={!hasValidName}
                error={!hasValidName}
                helperText={userDisplayName.length > maxCharLimit ? maxCharError : ''}
                FormHelperTextProps={helperTextProperties}
              >
                {appState}
              </TextField>
              <IconButton onClick={attemptSave} aria-label="submit" size="large">
                <DoneIcon />
              </IconButton>
              <IconButton onClick={handleCancel} aria-label="delete" size="large">
                <CancelIcon />
              </IconButton>
              <ErrorMessage
                open={popoverOpen}
                element={anchorElement}
                handleClose={() => setAnchorElement(null)}
                message={errorMessage}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Preview;
